var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartTfwp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E6",
  d: "M2.83 20.54v-7.198H0V12h7.247v1.342h-2.83v7.198zM13.133 17.045H9.758v3.486H8V12h5.555v1.424H9.758v2.203h3.375zm8.086 1.025L22.367 12h1.752l-1.892 8.531h-1.77l-1.389-5.707-1.388 5.707h-1.77L14.018 12h1.752l1.154 6.058 1.406-6.057h1.488l1.4 6.07zm5.607-.545v3.006h-1.758V12h3.328q.962 0 1.69.351.73.352 1.123 1 .393.647.393 1.473 0 1.254-.859 1.978-.858.723-2.376.723zm0-1.424h1.57q.698 0 1.064-.328t.366-.937q0-.627-.369-1.014t-1.02-.398h-1.61z"
})));
export default SvgChartTfwp;